// Modules
import { useSearchFilterIcon, SelectedItem, FilterSelectData } from "components/atoms/SearchFilterIcon/useSearchFilterIcon";
import { Popover } from "antd";
// Util
import getIcon from "utils/getIcon";

// Components, Types
import Filters, { FilterItem } from "components/molecules/Filters/Filters";
import RetroClaimFilters from "components/molecules/RetroClaimFilters/RetroClaimFilters";

// Styles
import styles from "components/atoms/SearchFilterIcon/SearchFilterIcon.module.css";

// Types
import { Filter as FilterType } from "redux/types";

export type SearchFilterIconProps = {
	label: string | JSX.Element;
	defaultSelectedFilter: Array<SelectedItem>;
	defaultSelectedFilterValues: Array<string>;
	onClick?: () => void;
	groupCode?: string;
	useRetroClaimFilter?: boolean;
	isGroupPendingClaims?: boolean;
};

type ComponentProps = {
	handleOnSelectFilter: (data: FilterSelectData) => void;
	handleOnResetFilter: () => void;
	showFilter: FilterType;
	filterItems: Array<{
		title: string;
		values: Array<FilterItem>;
	}>;
	selectedFilterValues: Array<string>;
};

const SearchFilterIcon = ({
	label,
	defaultSelectedFilter,
	defaultSelectedFilterValues,
	onClick,
	groupCode,
	useRetroClaimFilter = false,
	isGroupPendingClaims = false
}: SearchFilterIconProps) => {
	const componentProps: ComponentProps = useSearchFilterIcon({ defaultSelectedFilter, defaultSelectedFilterValues });
	const { handleOnSelectFilter, handleOnResetFilter, showFilter, filterItems, selectedFilterValues } = componentProps;

	// Choose which filter component to render
	const FilterComponent = useRetroClaimFilter ? RetroClaimFilters : Filters;

	return (
		<div className="flex relative">
			<Popover
				overlayClassName="filter_rolemanagement"
				placement={"bottom"}
				content={
					<FilterComponent
						filters={filterItems}
						selectedFilers={selectedFilterValues}
						onClick={handleOnSelectFilter}
						onReset={handleOnResetFilter}
						isGroupPendingClaims={isGroupPendingClaims}
					/>
				}
				open={!!(groupCode && showFilter?.[groupCode])}
			>
				<div className={styles?.filter_wrapper} onClick={onClick}>
					<div className={styles?.filter_icon}>{getIcon({ icon: "Filter" })}</div>
					<span className={styles?.filter_Text}>{label}</span>
				</div>
			</Popover>
		</div>
	);
};

export default SearchFilterIcon;
